import { render, staticRenderFns } from "./SubjectsEdit.vue?vue&type=template&id=7f0ebf10&"
import script from "./SubjectsEdit.vue?vue&type=script&lang=js&"
export * from "./SubjectsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports